/* 🤖 this file was generated by svg-to-ts */
export const siriusRows: {
  name: 'rows';
  data: string;
} = {
  name: 'rows',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4.5A1.5 1.5 0 0 0 3 6v3.75a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5h-15Zm0 1.5h15v3.75h-15V6ZM4.5 12.75a1.5 1.5 0 0 0-1.5 1.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18v-3.75a1.5 1.5 0 0 0-1.5-1.5h-15Zm0 1.5h15V18h-15v-3.75Z" fill="currentColor"/></svg>`
};
